import { render, staticRenderFns } from "./SlotSelector.vue?vue&type=template&id=74a52148"
import script from "./SlotSelector.vue?vue&type=script&lang=js"
export * from "./SlotSelector.vue?vue&type=script&lang=js"
import style0 from "./SlotSelector.vue?vue&type=style&index=0&id=74a52148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports